
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/our-boxes/[box]",
      function () {
        return require("private-next-pages/our-boxes/[box].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/our-boxes/[box]"])
      });
    }
  